/**
 * False positives detected on Sentry.
 */
export const appErrorFalsePositiveList: readonly string[] = [
  // Microsoft Edge for IPhone bug - Triggered on Video Elements - No known impact.
  "Can't find variable: logMutedMessage",
  // No known Impact.
  "ResizeObserver loop limit exceeded",
];
